import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section id="about" className="min-h-screen flex items-center justify-center px-6 py-20">
      <div className="max-w-4xl w-full">
        <h2 className="text-5xl md:text-7xl font-light mb-12">About</h2>
        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed">
          <p>
            Erika Hubbard, a Juilliard-trained violinist with a background in neuroscience from Columbia University, 
            has won awards at prestigious competitions and performed with renowned orchestras like the Princeton Symphony. 
            She brings a deep passion for performance and teaching to her role at Gifted Music School.
          </p>
          
          <div className="pt-6">
            <Link 
              to="/biography" 
              className="inline-block text-gray-900 border-b-2 border-gray-900 hover:border-gray-400 hover:text-gray-600 transition-colors text-lg font-light"
            >
              Read Full Biography →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}